import React, { useRef } from 'react';
import { withApollo } from 'react-apollo';
import PropTypes from 'prop-types';

import { dictionaryItem, mapDictionaryItems } from '../../hocs/withDictionary';
import { formatPriceWithCurrency } from '../../lib/format';
import {
  LoginLink,
  MembershipHeader,
  MembershipTitle,
  ToggleButtonColumnContainer,
} from './Availability.style';
import { Title } from '../ui';
import IbePropTypes from '../../IbePropTypes';
import MemberNonMemberBody from './MemberNonMemberBody';
import InfoIconWithModal from './InfoIconWithModal';
import Membership from './modals/Membership';
import RadioButton from '../ui/RadioButton/RadioButton';
import routes from '../../constants/routes';

const STRING_REPLACE_KEY = '{{Cost}}';

const AvailabilityMemberNonMember = ({
  client,
  handleMemberNonMemberChange,
  memberPrice,
  memberPricesAreSelected,
  nonMemberPrice,
  loginLink,
  numberOfNights,
}) => {
  const buttonLabels = useRef(mapDictionaryItems(client, {
    member: 'AvailabilityMemberNonMember__MemberButton',
    memberSelectedDescription: 'AvailabilityMemberNonMember__MemberButtonSelectedDescription',
    memberDescription: 'AvailabilityMemberNonMember__MemberButtonDescription',
    nonMember: 'AvailabilityMemberNonMember__NonMemberButton',
    nonMemberSelectedDescription: 'AvailabilityMemberNonMember__NonMemberButtonSelectedDescription',
    nonMemberDescriptionPerNight: 'AvailabilityMemberNonMember__NonMemberButtonDescriptionPerNight',
    nonMemberDescriptionPerStay: 'AvailabilityMemberNonMember__NonMemberButtonDescriptionPerStay',
  }));

  const labels = buttonLabels.current;

  const priceDifference = (nonMemberPrice || 0) - (memberPrice || 0);

  const safeNumberOfNights = numberOfNights ?? 1;
  const totalSaving = priceDifference * safeNumberOfNights;

  const savingString = formatPriceWithCurrency(totalSaving);

  const memberDescription = memberPricesAreSelected ?
    labels?.memberSelectedDescription :
    labels?.memberDescription.replace(STRING_REPLACE_KEY, savingString);

  const nonMemberDictionaryKey = numberOfNights > 0
    ? labels.nonMemberDescriptionPerStay
    : labels.nonMemberDescriptionPerNight;

  const nonMemberDescription = !memberPricesAreSelected
    ? labels?.nonMemberSelectedDescription
    : nonMemberDictionaryKey?.replace(STRING_REPLACE_KEY, savingString);

  const priceIsZero = totalSaving === 0 || priceDifference === 0;

  const showMemberDescription = !priceIsZero || memberPricesAreSelected;
  const showNonMemberDescription = !priceIsZero || memberPricesAreSelected;

  return (
    <>
      <MembershipHeader>
        <MembershipTitle>
          <Title dictionary={dictionaryItem('AvailabilityMemberNonMember')} tag={1} size={4} />
          <LoginLink href={loginLink}>Log in</LoginLink>
        </MembershipTitle>
        <InfoIconWithModal modalContent={<Membership />} />
      </MembershipHeader>
      <ToggleButtonColumnContainer>
        <RadioButton
          onClick={() => handleMemberNonMemberChange(true)}
          isSelected={memberPricesAreSelected}
        >
          <MemberNonMemberBody
            disabled={false}
            name={labels.member}
            description={showMemberDescription && memberDescription}
            selected={memberPricesAreSelected}
          />
        </RadioButton>
        <RadioButton
          onClick={() => handleMemberNonMemberChange(false)}
          isSelected={!memberPricesAreSelected}
        >
          <MemberNonMemberBody
            disabled={false}
            name={labels.nonMember}
            description={showNonMemberDescription && nonMemberDescription}
            selected={!memberPricesAreSelected}
          />
        </RadioButton>
      </ToggleButtonColumnContainer>
    </>
  );
};

AvailabilityMemberNonMember.propTypes = {
  client: PropTypes.shape(IbePropTypes.client).isRequired,
  handleMemberNonMemberChange: PropTypes.func.isRequired,
  memberPrice: PropTypes.number,
  memberPricesAreSelected: PropTypes.bool.isRequired,
  nonMemberPrice: PropTypes.number,
  loginLink: PropTypes.string,
  numberOfNights: PropTypes.number,
};

AvailabilityMemberNonMember.defaultProps = {
  memberPrice: undefined,
  nonMemberPrice: undefined,
  loginLink: routes.sites,
  numberOfNights: null,
};

export default withApollo(AvailabilityMemberNonMember);
